import { ReactElement } from 'react';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import linkResolver from '@adapters/prismic/utils/linkResolver';
import RichTextContainer from '../RichTextContainer';

interface RichTextBlockProps {
  text: RichTextBlock[];
  classNames?: string | string[];
}

const RichTextBlockComponent = ({
  text,
  classNames,
}: RichTextBlockProps): ReactElement => (
  <RichTextContainer classNames={classNames}>
    <RichText render={text} linkResolver={linkResolver} />
  </RichTextContainer>
);

export default RichTextBlockComponent;
